import { Category } from '@/modules/settings/categories/types/Category.ts'
import { appConfig } from '@/config/app.ts'

export interface CategoryState {
  isLoading: boolean
  categories: Category[]
  isCreateModalOpen: boolean
  editId: string | null
  filters: string
}

export const initialState: CategoryState = {
  isLoading: false,
  categories: [],
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
